export const INIT_INGREDIENTS_SUCCESS = 'INIT_INGREDIENTS';
export const INIT_INGREDIENTS_ERROR = 'INIT_INGREDIENTS_ERROR';
export const CHANGE_INGREDIENT = 'CHANGE_INGREDIENT';
export const RESET_INGREDIENTS = 'RESET_INGREDIENTS';
export const RANDOM_PIZZA = 'RANDOM_PIZZA';

export const SUBMIT_ORDER_START = 'SUBMIT_ORDER_START'
export const SUBMIT_ORDER_SUCCESS = 'SUBMIT_ORDER_SUCCESS'
export const SUBMIT_ORDER_ERROR = 'SUBMIT_ORDER_ERROR'

export const FETCH_ORDERS_START = 'FETCH_ORDERS_START';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_ERROR = 'FETCH_ORDERS_ERROR';

export const DELETE_ORDERS_SUCCESS = 'DELETE_ORDERS_SUCCESS';
export const DELETE_ORDERS_ERROR = 'DELETE_ORDERS_ERROR';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';